/*
 * @Author: Teemo Ding
 * @Date: 2022-02-11 09:58:42
 * @LastEditTime: 2022-06-29 15:05:05
 * @LastEditors: Teemo Ding
 * @FilePath: /unifyxp-v2-store-portal/src/pages/AuditTrail/Communication/CommunicationDetail/tool.ts
 */
export const breadcrumbData = (orderNo, { getI18n }) => [
  {
    url: '/',
    name: getI18n('general.sider.home'),
  },
  {
    url: '/communicationList',
    name: getI18n('communication.communicationList.communication'),
  },
  {
    url: '',
    name: `#${orderNo}`,
  },
];
